export enum ButtonSize {
  ExtraSmall = 'extra-small',
  Small = 'small',
  Large = 'large',
  Default = 'default'
}
